import React from 'react';
import { Checkbox } from "@/components/ui/checkbox";
import { FormControl, FormItem, FormLabel, FormField } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { SortableOption } from "@/types/fieldsOptions";
interface OptionCheckboxProps {
  option: SortableOption;
  form: UseFormReturn<any>;
  name: string;
}
export const OptionCheckbox = ({
  option,
  form,
  name
}: OptionCheckboxProps) => {
  return <FormField key={option.id} control={form.control} name={name} render={({
    field
  }) => <FormItem key={option.id} className="flex flex-row items-start space-x-2 space-y-0 mb-1 py-2">
          <FormControl>
            <Checkbox checked={field.value?.includes(option.id)} onCheckedChange={checked => {
        const current = field.value || [];
        const updated = checked ? [...current, option.id] : current.filter((value: string) => value !== option.id);
        field.onChange(updated);
      }} />
          </FormControl>
          <FormLabel className="font-normal cursor-pointer text-left mt-0 pt-0">
            {option.label}
          </FormLabel>
        </FormItem>} />;
};